export default __webpack_public_path__ + "static/media/ZITI.f0aad5af.ttf";